// Rude words, for a list that can be SHARED (Alan, 27 Sep). A homework list is minted with a
// public code and handed to other households, and the words in it are read out to children — so
// a misread cell, a joke typed in, or a suggestion the reader offers must never carry one of
// these along for the ride.
//
// WHOLE WORDS ONLY, and this is the whole point of the file. Substring matching is the classic
// trap: it fails "Scunthorpe", "grass", "assignment", "class", "cockerel", "Essex", "shiitake",
// "Titchfield". Everything below is compared against a token that has been cut out of the text at
// its non-letter boundaries, so "grass" is never "ass" and "class" is never anything at all.
//
// Deliberately short, and it errs towards letting a word through. Two kinds are kept out on
// purpose: anything with an innocent homework meaning (see the note below), and mild words like
// "crap" that are not worth refusing a child's spelling list over. What is left is common
// profanity and racial slurs — what a child would be upset to be shown, or a parent to find in a
// list a stranger sent them. Add to it when something real gets through, not pre-emptively.
// CC, 27 Sep: several words on the first cut of this list are ordinary homework words — a blue
// TIT, a COCK as the bird, a DYKE in geography, a SLAG heap, PRICK your finger, a SHAG as the
// cormorant, PUSSY willow. Blocking a list because a child's real spelling word is on it is a
// worse failure than letting one of those through in a shared list, and telling a parent their
// child's spelling is offensive blames them for something they did not do. They are OUT. What is
// left carries no innocent meaning a primary or prep-school list would ever need.
const RUDE = new Set([
  "arse", "arsehole", "arseholes", "arses",
  "bastard", "bastards",
  "bitch", "bitches",
  "bollock", "bollocks",
  "coon", "coons",
  "cunt", "cunts",
  "dickhead", "dickheads",
  "fag", "fags", "faggot", "faggots",
  "fuck", "fucks", "fucked", "fucker", "fuckers", "fucking",
  "gook", "gooks",
  "kike", "kikes",
  "nigger", "niggers", "nigga", "niggas",
  "paki", "pakis",
  "piss", "pissed", "pisses", "pissing",
  "shit", "shits", "shitting", "shitty",
  "slut", "sluts",
  "spaz", "spazz",
  "tosser", "tossers",
  "twat", "twats",
  "wank", "wanker", "wankers", "wanking",
  "whore", "whores",
  "wog", "wogs",
]);

// Is this single word rude? The word is lower-cased and stripped of anything that is not a
// letter, so "Shit." and "shit" are the same question. A word containing one is NOT rude:
// "cockerel" is a bird.
export function isRudeWord(word) {
  const w = String(word || "").toLowerCase().replace(/[^a-z]/g, "");
  return !!w && RUDE.has(w);
}

// Does this phrase contain a rude word as a word of its own? Splitting on every non-letter is
// what keeps "Scunthorpe" and "grasshopper" out of it.
export function containsRudeWord(text) {
  return String(text || "").toLowerCase().split(/[^a-z]+/).some((w) => w && RUDE.has(w));
}

export const RUDE_WORD_COUNT = RUDE.size;
